import { Skeleton } from '@/components/ui/skeleton'
import { Card } from '@/components/ui/card'

export function BlogGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="flex flex-wrap gap-4 sm:gap-6 lg:gap-8 max-w-6xl mx-auto">
      {Array.from({ length: count }).map((_, i) => (
        <Card
          key={i}
          className="overflow-hidden shadow-md ring-1 ring-border
                     flex flex-col basis-full sm:basis-[calc(50%-0.75rem)]
                     lg:basis-[calc(33.333%-1.333rem)]"
        >
          <Skeleton className="h-40 sm:h-48 w-full" />
          <div className="p-4 sm:p-5 lg:p-6 flex flex-col flex-1">
            <Skeleton className="h-4 sm:h-5 w-24 mb-2 sm:mb-3 rounded-full" />
            <Skeleton className="h-5 sm:h-6 w-3/4 mb-1.5 sm:mb-2" />
            <Skeleton className="h-3.5 sm:h-4 w-full mb-1.5 sm:mb-2" />
            <Skeleton className="h-3.5 sm:h-4 w-2/3 mb-4 sm:mb-6" />
            <div className="mt-auto flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
              <Skeleton className="h-3.5 sm:h-4 w-24" />
              <Skeleton className="h-3.5 sm:h-4 w-16" />
            </div>
          </div>
        </Card>
      ))}
    </div>
  )
}

export function BlogPaginationSkeleton({ pages = 3 }: { pages?: number }) {
  return (
    <div className="mt-4 sm:mt-8 md:mt-12 flex justify-center items-center gap-1.5 sm:gap-2">
      <Skeleton className="h-8 w-8 sm:h-10 sm:w-10 rounded-md" />
      <div className="flex gap-1 sm:gap-1.5">
        {Array.from({ length: pages }).map((_, i) => (
          <Skeleton key={i} className="h-8 w-8 sm:h-10 sm:w-10 rounded-md" />
        ))}
      </div>
      <Skeleton className="h-8 w-8 sm:h-10 sm:w-10 rounded-md" />
    </div>
  )
}
